import React from 'react';

import StatusBadge from 'shared/ui/Status/StatusBadge';
import styles from 'shared/ui/Status/StatusBadge.module.scss';

import {colorMonitorStatus, MonitorStatus, translateMonitorStatus} from '../../lib/monitorStatus';

interface IMonitorStatusBadgeProps {
    status: MonitorStatus,
}

const MonitorStatusBadge: React.FC<IMonitorStatusBadgeProps> = ({status}) => (
    <StatusBadge
        color={colorMonitorStatus(status)}
        label={translateMonitorStatus(status)}
        className={styles.forMonitor}
        textOnly
    />
);

export default MonitorStatusBadge;
